import {
  GET_ACC_BELONG_AGENT,
  GET_BUSINESS_PARTNER,
  GET_BUSINESS_PARTNER_BANLCE,
  GET_DISTRICT,
  GET_NATIONAL,
  GET_PROVINCE,
  GET_TRANS,
  MAINTENANCE,
} from './index';
import { logoutApi } from './../../../services/authApi';
import { getMeApi } from 'app/services/authApi';
import { take, select, fork, put, call, takeLatest } from 'redux-saga/effects';
import { TYPE_COOKIE } from 'utils/constants';
import { getCookie, removeCookie } from 'utils/cookies';
import { appActions, GET_LAYOUT, GET_ME, LOGIN } from '.';
import { clearAllLS } from 'utils/localStorage';
import {
  getDistrictApi,
  getLayoutApi,
  getMaintenanceApi,
  getNationalApi,
  getProvinceApi,
  getTranslationsApi,
  getTranslationsB2BApi,
} from 'app/services/appApi';
import { Router } from 'react-router-dom';
import { history } from 'utils/history';
import { selectIsLogged, selectTranslations } from './selectors';
import {
  getAccountListBelongAgentApi,
  getBusinessPartnerApi,
  getBusinessPartnerBanlceApi,
} from 'app/services/agentApi';

export function* watchAndLog() {
  while (true) {
    const styleConsole =
      'background: yellow; font-weight: bold; color: #40a9ff8c;';
    const action = yield take('*');
    const state = yield select();
    if (
      action.type !== '@@router/LOCATION_CHANGE' &&
      action.type !== 'app/updateMediaUploadingProgress' &&
      action.type !== 'reapop/upsertNotification' &&
      action.type !== 'reapop/dismissNotification'
    ) {
      // console.group(action.type);
      // console.log('%cBefore State', styleConsole, state);
      // console.info('%cDispatching', styleConsole, action);
      // console.log('%cNext State', styleConsole, state);
      // console.groupEnd();
    }
  }
}

function* watchIsLogged() {
  while (true) {
    yield take(LOGIN.SUCCESS);
    yield put(appActions.changeIsLogged({ isLogged: true }));
  }
}

export function* getMe({ payload }) {
  try {
    const { data } = yield call(getMeApi, payload);
    yield put(GET_ME.success(data));
  } catch {
    yield put(GET_ME.failure());
  }
}

export function* getLayout() {
  try {
    const response = yield call(getLayoutApi);
    yield put(GET_LAYOUT.success(response.data));
  } catch {
    yield put(GET_LAYOUT.failure());
  }
}

export function* getTranslations() {
  try {
    const isLogin = yield select(selectIsLogged);
    const response = yield call(getTranslationsApi);
    if (isLogin) {
      const responseB2B = yield call(getTranslationsB2BApi);
      yield put(
        GET_TRANS.success({ ...response.data, ...(responseB2B?.data || {}) }),
      );
      return;
    }
    yield put(GET_TRANS.success(response.data));
  } catch {
    yield put(GET_TRANS.failure());
  }
}

export function* getNational() {
  try {
    const response = yield call(getNationalApi);
    yield put(GET_NATIONAL.success(response.data));
  } catch {
    yield put(GET_NATIONAL.failure());
  }
}

export function* getProvince({ payload }) {
  try {
    const response = yield call(getProvinceApi, payload);
    yield put(GET_PROVINCE.success(response.data));
  } catch {
    yield put(GET_PROVINCE.failure());
  }
}

export function* getDistrict({ payload }) {
  try {
    const response = yield call(getDistrictApi, payload);
    yield put(GET_DISTRICT.success(response.data));
  } catch {
    yield put(GET_DISTRICT.failure());
  }
}

function* logout({ payload }: any) {
  try {
    const { callback } = payload;
    const token = yield call(getCookie, TYPE_COOKIE.TOKEN);
    if (token) yield call(logoutApi);
    callback && callback();
    yield call(removeCookie, TYPE_COOKIE.TOKEN);
    yield call(clearAllLS);
    yield put(appActions.changeIsLogged({ isLogged: false }));
  } catch (err) {}
}

export function* getBusinessPartner() {
  try {
    const { data } = yield call(getBusinessPartnerApi);
    yield put(GET_BUSINESS_PARTNER.success(data));
  } catch {
    yield put(GET_BUSINESS_PARTNER.failure());
  }
}

export function* getAccListBelongAgent() {
  try {
    const { data } = yield call(getAccountListBelongAgentApi, {});
    yield put(GET_ACC_BELONG_AGENT.success(data.data));
  } catch {
    yield put(GET_ACC_BELONG_AGENT.failure());
  }
}

export function* getBusinessPartnerBanlce() {
  try {
    const { data } = yield call(getBusinessPartnerBanlceApi);
    const banlceInfo = data?.BalanceInfo;
    yield put(
      GET_BUSINESS_PARTNER_BANLCE.success({
        available_limit: +banlceInfo.Exposure_amount,
        granted_limit: +banlceInfo.Credit_limit,
        debt: +banlceInfo.Credit_exposure,
        balance: +banlceInfo.Amount,
      }),
    );
  } catch {
    yield put(GET_BUSINESS_PARTNER_BANLCE.failure());
  }
}

export function* getMaintenance({ payload }) {
  try {
    const { data } = yield call(getMaintenanceApi);
    yield put(MAINTENANCE.success(data));
    payload?.onSuccess?.(data);
  } catch {
    yield put(MAINTENANCE.failure());
  }
}

export function* appSaga() {
  if (process.env.NODE_ENV === 'development') yield fork(watchAndLog);
  yield fork(watchIsLogged);
  yield takeLatest(GET_ME.TRIGGER, getMe);
  yield takeLatest(GET_LAYOUT.TRIGGER, getLayout);
  yield takeLatest(GET_TRANS.TRIGGER, getTranslations);
  yield takeLatest(GET_NATIONAL.TRIGGER, getNational);
  yield takeLatest(GET_PROVINCE.TRIGGER, getProvince);
  yield takeLatest(GET_DISTRICT.TRIGGER, getDistrict);
  yield takeLatest(appActions.logout.type, logout);
  yield takeLatest(GET_BUSINESS_PARTNER, getBusinessPartner);
  yield takeLatest(GET_ACC_BELONG_AGENT, getAccListBelongAgent);
  yield takeLatest(GET_BUSINESS_PARTNER_BANLCE, getBusinessPartnerBanlce);
  yield takeLatest(MAINTENANCE, getMaintenance);
}
